// src/pages/ChapterOne.js
import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ChapterTemplate from "../components/ChapterTemplate";
import { getChapterMeta, markChapterComplete } from "../utils/progression";

// Popups shown after first clear
import ParentsNoteModal from "../components/ParentsNoteModal";
import SaveProgressPrompt from "../components/SaveProgressPrompt";

// 🎵 Twinkle Twinkle — lines (6 neat rows)
const twinkleLines = [
  ["C","C","G","G","A","A","G"],
  ["F","F","E","E","D","D","C"],
  ["G","G","F","F","E","E","D"],
  ["G","G","F","F","E","E","D"],
  ["C","C","G","G","A","A","G"],
  ["F","F","E","E","D","D","C"],
];

// Flat sequence for listeners
const twinkleMelody = twinkleLines.flat();

// 🖼️ Chapter 1 story slides (now 4 total)
// NEW Slide 2 image to export: /images/ChapterOne/Slide-2-Wis-Twinkle.png
const ChapterOneStory = [
  {
    image: "/images/ChapterOne/Slide 1-Doron-Aprroaching.png",
  },
  {
    image: "/images/ChapterOne/Slide-2-Wis-Twinkle.png",
  },
  {
    image: "/images/ChapterOne/Chapter1 Slide 4.png",
  },
  {
    image: "/images/Doron-IntroSlide.png",
    text: "Ready? Play it on your piano — we’ll listen as the correct notes will turn green!",
    melody: true,
  },
];

export default function ChapterOne() {
  const navigate = useNavigate();
  const CHAPTER = 1;
  const meta = getChapterMeta(CHAPTER);

  const [matchedNotes, setMatchedNotes] = useState([]);
  const [firstCleared, setFirstCleared] = useState(false);
  const [parentsOpen, setParentsOpen] = useState(false);

  const handleFirstClear = useCallback(() => {
    setFirstCleared((prev) => {
      if (prev) return true;
      try { markChapterComplete(CHAPTER); } catch {}
      setParentsOpen(true);
      return true;
    });
  }, []);

  const handleRealComplete = useCallback(() => { handleFirstClear(); }, [handleFirstClear]);
  const handleVirtualComplete = useCallback(() => { handleFirstClear(); }, [handleFirstClear]);

  return (
    <>
      <ChapterTemplate
        chapterNumber={CHAPTER}
        chapterTitle={meta?.title || "Dragon Sleep"}
        storySlides={ChapterOneStory}
        targetMelody={twinkleMelody}
        melodyLines={twinkleLines}
        matchedNotes={matchedNotes}
        onNoteMatched={setMatchedNotes}
        onRealComplete={handleRealComplete}
        onVirtualComplete={handleVirtualComplete}
        unlockNextChapterPath="/chapter-2"
        skillPoints={meta?.skillPoints ?? 6}
        layoutMode="cinema"
        songTitle="Twinkle Twinkle Little Star"
        /* 🔺 Larger slide area only (melody view unchanged) */
        slideHeightClass="h-[50vh] sm:h-[55vh] lg:h-[58vh]"
      />

      {firstCleared && (
        <div className="mt-3 w-full flex justify-center">
          <button
            onClick={() => navigate("/constellation")}
            className="px-5 py-2 rounded-full bg-yellow-400 text-slate-900 font-extrabold shadow"
          >
            ✨ View Star Quest (Constellation)
          </button>
        </div>
      )}

      <ParentsNoteModal open={parentsOpen} onClose={() => setParentsOpen(false)} />
      <SaveProgressPrompt trigger={firstCleared} />
    </>
  );
}
